module.exports = "<p>\r\n  supervisor-configurations works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/supervisor-configurations/supervisor-configurations.component.html
// module id = ../../../../../src/app/supervisor-configurations/supervisor-configurations.component.html
// module chunks = 0